module.exports = __webpack_public_path__ + "img/Last image OOBE Spanish.7e3b7dcd.png";